
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as htmlToImage from 'html-to-image';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import ReactDOM from 'react-dom/client';
import jsPDF from 'jspdf';
import Papa from 'papaparse';
import Modal from './Modal';
import TeklifGirisFormu from './TeklifGirisFormu';
import ProformaPreview from './ProformaPreview';
import EtiketSablonu from './EtiketSablonu';
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';
import TickIcon from './assets/images/tick_icon.svg';
import CrossIcon from './assets/images/cross_icon.svg';
import WhatsappIcon from './assets/images/whatsapp_icon.svg';
import DownloadIcon from './assets/images/download_icon.svg';
import PTTLogo from './assets/images/ptt_logo.svg';
import ParasutLogo from './assets/images/parasut_logo.svg';

// API URL'i tanımlama
const baseURL = process.env.REACT_APP_API_URL;

// DEBUG: Environment variable kontrolü
console.log('🔧 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('🌐 baseURL:', baseURL);

function TeklifListesi() {
    // --- STATE VE REF TANIMLAMALARI ---
    const [teklifler, setTeklifler] = useState([]);
    const [seciliTarih, setSeciliTarih] = useState(new Date().toISOString().substring(0, 7)); // YYYY-MM formatı
    const [acikTeklifId, setAcikTeklifId] = useState(null);
    
    // Kullanıcı rolünü local storage'dan al
    const [userRole, setUserRole] = useState(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        return user ? user.rol : null;
    });
    const [detayData, setDetayData] = useState(null);
    const [proformaTel, setProformaTel] = useState('');
    const [musteriNotu, setMusteriNotu] = useState('');
    const [kargoHareketleri, setKargoHareketleri] = useState([]);
    const [kargoSorguLoading, setKargoSorguLoading] = useState(false);
    const [faturaKisiAdi, setFaturaKisiAdi] = useState('');
    const [faturaDuzenleModalAcik, setFaturaDuzenleModalAcik] = useState(false);
    const [resmilestirLoading, setResmilestirLoading] = useState({}); // Fatura ID'lerine göre loading state
    const [faturaStatuslari, setFaturaStatuslari] = useState({}); // Fatura durumları için cache
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCsvModalOpen, setIsCsvModalOpen] = useState(false); // CSV upload modal için ayrı state
    const [editingTeklifId, setEditingTeklifId] = useState(null);
    const [seciliTeklifler, setseciliTeklifler] = useState([]);
    const [aramaTerimi, setAramaTerimi] = useState('');
    const [acilTeklifler, setAcilTeklifler] = useState([]); // Acil gönderilecek tekliflerin ID'lerini tutacak
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [orderCount, setOrderCount] = useState(0);
    const fileInputRef = useRef(null);
    
    // Tarih seçimi için modal state'leri
    const [tarihModalAcik, setTarihModalAcik] = useState(false);
    const [secilenTarih, setSecilenTarih] = useState(new Date().toISOString().split('T')[0]);
    const [tarihModalCallback, setTarihModalCallback] = useState(null);

    // Tarih seçimi modal'ını açan fonksiyon
    const openTarihModal = (callback) => {
        setSecilenTarih(new Date().toISOString().split('T')[0]);
        setTarihModalCallback(() => callback);
        setTarihModalAcik(true);
    };
    
    // Tarih seçimi onaylandığında çağrılan fonksiyon
    const handleTarihOnayla = () => {
        if (tarihModalCallback) {
            tarihModalCallback(secilenTarih);
        }
        setTarihModalAcik(false);
    };

    // Teklifleri backend'den çeken ana fonksiyon
    const fetchTeklifler = () => {
        if (!seciliTarih) return; // Tarih seçili değilse boşuna istek atma
        
        const [year, month] = seciliTarih.split('-');
        
        fetch(`${baseURL}/api/teklifler?year=${year}&month=${month}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error('Teklifler yüklenemedi');
                }
                return res.json();
            })
            .then(data => {
                console.log('📋 TEKLİFLER YÜKLENDİ:', data);
                setTeklifler(data);
            })
            .catch(err => {
                console.error('❌ Teklif yükleme hatası:', err);
                alert('Teklifler yüklenirken hata oluştu: ' + err.message);
            });
    };

    // Component ilk yüklendiğinde ve seçili tarih değiştiğinde veriyi çeker
    useEffect(() => {
        fetchTeklifler();
    }, [seciliTarih]);

    // Siparişler yüklendikten sonra paraşüt faturalarının durumunu otomatik kontrol et
    useEffect(() => {
        console.log("🔄 Fatura kontrol useEffect tetiklendi!");
        console.log("📊 teklifler length:", teklifler.length);
        console.log("📋 teklifler array:", teklifler);
        
        if (teklifler.length > 0) {
            console.log("🔍 Sipariş listesi yüklendi, fatura durumları kontrol ediliyor...");
            
            // Paraşüt fatura ID'si olan siparişleri bul
            const faturaIdleri = teklifler
                .filter(teklif => teklif.parasut_fatura_id)
                .map(teklif => teklif.parasut_fatura_id);
            
            console.log("📋 Sipariş detayları:", teklifler.map(s => ({ 
                id: s.id, 
                teklif_no: s.teklif_no, 
                parasut_fatura_id: s.parasut_fatura_id 
            })));
            console.log("📄 Bulunan fatura ID'leri:", faturaIdleri);
            
            if (faturaIdleri.length > 0) {
                console.log(`📄 ${faturaIdleri.length} adet fatura durumu kontrol edilecek`);
                
                // Fatura kontrollerini hızlı bir şekilde yap (100ms gecikme)
                faturaIdleri.forEach((faturaId, index) => {
                    setTimeout(() => {
                        checkFaturaStatusOtomatik(faturaId)
                            .then(() => console.log(`✅ Fatura ${faturaId} durumu güncellendi`))
                            .catch(err => console.warn(`⚠️ Fatura ${faturaId} durumu güncellenemedi:`, err));
                    }, index * 100); // 500ms'den 100ms'ye düşürdük
                });
            }
        } else {
            console.log("📝 Henüz sipariş yüklenmedi veya fatura ID'si olan sipariş yok");
        }
    }, [teklifler, teklifler.length]); // Hem array hem length değişiminde tetikle

    // Butonları devre dışı bırakma kontrolü
    const isButtonDisabled = () => {
        return userRole === 'depo_operatoru';
    };

    const handleBrowseClick = () => {
        // Gizli dosya girişini tetikle
        fileInputRef.current.click();
    };

    // Kargo güncelleme butonu için özel disabled kontrolü
    const isShipmentUpdateDisabled = () => {
        // Hem depo operatörü hem de operatör kullanıcıları için pasif
        return userRole === 'depo_operatoru' || userRole === 'operator';
    };

    // Resmileştir butonu için özel disabled kontrolü
    const isResmilestirDisabled = (faturaId) => {
        return isButtonDisabled() || resmilestirLoading[faturaId] || false;
    };

    // Acil teklifleri localStorage'dan yükle
    useEffect(() => {
        const savedAcilTeklifler = localStorage.getItem('acilTeklifler');
        if (savedAcilTeklifler) {
            setAcilTeklifler(JSON.parse(savedAcilTeklifler));
        }
    }, []);
    
    // Acil teklifler değiştiğinde localStorage'a kaydet
    useEffect(() => {
        if (acilTeklifler.length > 0) {
            localStorage.setItem('acilTeklifler', JSON.stringify(acilTeklifler));
        }
    }, [acilTeklifler]);
    
    useEffect(() => {
        if (detayData) {
            setProformaTel(detayData.musteri?.telefon_numarasi || '');
            setMusteriNotu(detayData.teklif_notu || '');
        }
        // Detay bandı kapandığında veya değiştiğinde önceki hareketleri temizle
        if (!detayData) {
            setKargoHareketleri([]);
        }
    }, [detayData]);

    // Keyboard shortcut - Y tuşu ile yeni sipariş aç
    useEffect(() => {
        const handleKeyPress = (e) => {
            // Input elementlerine odaklanılmışsa kısayolu çalıştırma
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
                return;
            }
            
            // Y tuşuna basıldığında ve buton aktifse yeni sipariş aç
            if (e.key.toLowerCase() === 'y' && !isButtonDisabled()) {
                e.preventDefault();
                handleModalOpen();
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    // Otomatik fatura durumu kontrolü
    const checkFaturaStatusOtomatik = async (faturaId) => {
        if (!faturaId) return; // Fatura ID'si yoksa kontrol etme

        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            console.log(`Fatura durumu sorgulanıyor: ${faturaId}`);
            const response = await fetch(`api/faturalar/${faturaId}/durum`, {
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status === 401) return;

            const data = await response.json();
            console.log(`Paraşüt API yanıtı alındı (${faturaId}):`, JSON.stringify(data, null, 2));
            
            if (response.ok) {
                // Orijinal veri yapısını koru ama tam API yanıtını da ekle
                const yeniFaturaDurumu = {
                    is_finalized: data.is_finalized,
                    fatura_bilgileri: data.fatura_bilgileri,
                    mesaj: data.mesaj,
                    // Tam API yanıtını raw_data olarak ekle
                    raw_data: data
                };
                
                // Eğer Paraşüt API'den gelen yanıt farklı formatta ise
                if (data.data && data.data.attributes) {
                    // API yanıtından fatura numarasını doğrudan çıkartmaya çalış
                    if (data.data.attributes.invoice_no) {
                        // data.data.attributes yapısı varsa ve invoice_no içeriyorsa
                        if (!yeniFaturaDurumu.fatura_bilgileri) {
                            yeniFaturaDurumu.fatura_bilgileri = {};
                        }
                        yeniFaturaDurumu.fatura_bilgileri.fatura_no = data.data.attributes.invoice_no;
                        console.log(`Fatura numarası alternatif yapıdan alındı: ${data.data.attributes.invoice_no}`);
                    }
                    
                    // Finalized durumu da attributes içinde olabilir
                    if (data.data.attributes.invoice_series_id) {
                        yeniFaturaDurumu.is_finalized = true;
                    }
                }
                
                // State'i güncelle
                setFaturaStatuslari(prev => ({
                    ...prev,
                    [faturaId]: yeniFaturaDurumu
                }));
                
                console.log(`Fatura durumu alındı: ${faturaId}`, yeniFaturaDurumu);
                
                // Ayrıca hemen yanıt olarak da döndürelim (toplu indirme için)
                return yeniFaturaDurumu;
            }
        } catch (error) {
            console.error("Otomatik fatura durumu kontrol hatası:", error);
        }
    };

    const handleSecim = (teklifId) => {
        setseciliTeklifler(prev => 
            prev.includes(teklifId) 
                ? prev.filter(id => id !== teklifId)
                : [...prev, teklifId]
        );
    };

    const handleTumunuSec = (e) => {
        if (e.target.checked) {
            setseciliTeklifler(filtrelennisTeklifler.map(s => s.id));
        } else {
            setseciliTeklifler([]);
        }
    };

    const handleBeklemeyeAl = async (teklifId) => {
        const isConfirmed = window.confirm("Bu sipariş bekleyenler listesine taşınacaktır. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/teklifler/${teklifId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Beklemede' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // --- DEĞİŞİKLİK BURADA ---
            // 1. Ana sipariş listesini yenileyerek satır renginin güncellenmesini sağla.
            fetchTeklifler(); 
            
            // 2. Açık olan detay bandının verisini de anında güncelle.
            // Bu, butonun "Beklemede" olarak değişmesini sağlar.
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Beklemede'
            }));
            // -------------------------

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        console.log('📁 Dosya seçildi:', file);
        
        if (!file) {
            console.log('❌ Dosya seçilmedi');
            return;
        }
        
        console.log('📄 Dosya detayları:', {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified
        });

        setSelectedFile(file);
        setUploadStatus('Ön okuma yapılıyor...');

        // PapaParse ile CSV'yi tara ve sipariş sayısını bul
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                console.log('📊 PapaParse sonucu:', results);
                const data = results.data;
                console.log('📊 Veri sayısı:', data.length);
                if (data.length > 0) {
                    console.log('📋 İlk satır:', data[0]);
                    console.log('📋 Kolonlar:', Object.keys(data[0]));
                }
                
                // 'Sipariş numarası' sütununa göre benzersiz siparişleri say
                const uniqueOrderIds = new Set(data.map(item => item['Sipariş numarası']));
                console.log('📦 Benzersiz sipariş sayısı:', uniqueOrderIds.size);
                setOrderCount(uniqueOrderIds.size);
                setIsCsvModalOpen(true); // CSV onay ekranını aç
                setUploadStatus(''); // Durum mesajını temizle
            },
            error: (error) => {
                console.error('❌ CSV okuma hatası:', error);
                setUploadStatus(`CSV okuma hatası: ${error.message}`);
                setSelectedFile(null);
            }
        });
    };
    
    const handleAcilGonder = async (teklifId) => {
        const isConfirmed = window.confirm("Bu sipariş acil gönderilecek olarak işaretlenecek. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/teklifler/${teklifId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Acil' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // Acil teklifler listesine ekle
            setAcilTeklifler(prevList => [...prevList, teklifId]);
            
            // Ana teklif listesini yenile
            fetchTeklifler(); 
            
            // Açık olan detay bandının verisini güncelle
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Acil'
            }));

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };
    
    const handleNormalGonder = async (teklifId) => {
        const isConfirmed = window.confirm("Bu sipariş normal gönderilecek olarak işaretlenecek. Emin misiniz?");
        if (!isConfirmed) return;

        try {
            const response = await fetch(`/api/teklifler/${teklifId}/durum-guncelle`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ kargo_durumu: 'Normal' })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.hata);
            
            alert(data.mesaj);
            
            // Acil teklifler listesinden çıkar
            setAcilTeklifler(prevList => prevList.filter(id => id !== teklifId));
            
            // Ana teklif listesini yenile
            fetchTeklifler(); 
            
            // Açık olan detay bandının verisini güncelle
            setDetayData(prevDetayData => ({
                ...prevDetayData,
                kargo_durumu: 'Normal'
            }));

        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    // Gönderim numarasını kaydetme fonksiyonu
    const handleSaveGonderimNumarasi = async () => {
        if (!detayData) return;

        try {
            // Yeni gönderim numarası güncelleme endpoint'ini kullan
            const response = await fetch(`/api/teklifler/${detayData.id}/gonderim-numarasi-guncelle`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ 
                    telefon_numarasi: proformaTel 
                })
            });

            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.hata || 'Gönderim numarası kaydedilemedi');
            }
            
            // Detay verilerini güncelle
            setDetayData(prevData => ({
                ...prevData,
                musteri: {
                    ...prevData.musteri,
                    telefon_numarasi: proformaTel
                }
            }));
            
            // Başarı mesajı göster
            alert('Gönderim numarası başarıyla kaydedildi.');
            
            alert('Gönderim numarası başarıyla kaydedildi');
            
        } catch (error) {
            console.error('Gönderim numarası kaydetme hatası:', error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleTopluIndir = async (tip) => {
        if (seciliTeklifler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }
        
        alert(`${seciliTeklifler.length} adet ${tip} indiriliyor. Lütfen bekleyin...`);
        const zip = new JSZip();
        const geciciRenderAlani = document.createElement('div');
        geciciRenderAlani.style.position = 'absolute';
        geciciRenderAlani.style.left = '-9999px';
        document.body.appendChild(geciciRenderAlani);

        try {
            for (const id of seciliTeklifler) {
                try {
                    const res = await fetch(`/api/teklifler/${id}`, { cache: 'no-cache' });
                    const detay = await res.json();
                    if (!res.ok) { continue; }

                    // Eğer fatura numarası kullanılacak bir etiket ise, fatura durumunu kontrol et
                    if (tip === 'Etiket' && detay.parasut_fatura_id) {
                        try {
                            console.log(`[ID: ${id}] Fatura durumu kontrol ediliyor... Fatura ID: ${detay.parasut_fatura_id}`);
                            
                            // Fatura durumunu her defasında kontrol et (API cevabı değişmiş olabilir)
                            const faturaDurumu = await checkFaturaStatusOtomatik(detay.parasut_fatura_id);
                            
                            if (faturaDurumu) {
                                console.log(`[ID: ${id}] Fatura durumu alındı:`, JSON.stringify(faturaDurumu, null, 2));
                                
                                // Fatura bilgilerini her durumda güncelle
                                setFaturaStatuslari(prev => ({
                                    ...prev,
                                    [detay.parasut_fatura_id]: faturaDurumu
                                }));
                                
                                // Eklenen detaylı debug bilgisi
                                if (faturaDurumu.fatura_bilgileri && faturaDurumu.fatura_bilgileri.fatura_no) {
                                    console.log(`[ID: ${id}] E-Fatura numarası bulundu (standart): ${faturaDurumu.fatura_bilgileri.fatura_no}`);
                                } else if (faturaDurumu.raw_data && faturaDurumu.raw_data.data && 
                                          faturaDurumu.raw_data.data.attributes && 
                                          faturaDurumu.raw_data.data.attributes.invoice_no) {
                                    console.log(`[ID: ${id}] E-Fatura numarası bulundu (alternatif): ${faturaDurumu.raw_data.data.attributes.invoice_no}`);
                                } else {
                                    console.log(`[ID: ${id}] E-Fatura numarası bulunamadı, ham API cevabı:`, 
                                                JSON.stringify(faturaDurumu.raw_data, null, 2));
                                }
                                
                                // Detay nesnesine de fatura numarasını ekle
                                if (faturaDurumu.fatura_bilgileri && faturaDurumu.fatura_bilgileri.fatura_no) {
                                    detay.fatura_no = faturaDurumu.fatura_bilgileri.fatura_no;
                                } else if (faturaDurumu.raw_data && faturaDurumu.raw_data.data && 
                                          faturaDurumu.raw_data.data.attributes && 
                                          faturaDurumu.raw_data.data.attributes.invoice_no) {
                                    detay.fatura_no = faturaDurumu.raw_data.data.attributes.invoice_no;
                                }
                            } else {
                                console.log(`[ID: ${id}] Fatura durumu alınamadı`);
                            }
                            
                        } catch (error) {
                            console.error(`[ID: ${id}] Fatura durumu kontrol edilemedi, varsayılan ad kullanılacak:`, error);
                        }
                    }

                    const componentWrapper = document.createElement('div');
                    geciciRenderAlani.appendChild(componentWrapper);
                    
                    const root = ReactDOM.createRoot(componentWrapper);
                    
                    // --- DEĞİŞİKLİK BURADA: Yeni prop'u gönderiyoruz ---
                    const ComponentToRender = tip === 'Proforma' 
                        ? <ProformaPreview detayData={detay} isForDownload={true} /> 
                        : <EtiketSablonu teklif={detay} />;

                    root.render(<React.StrictMode>{ComponentToRender}</React.StrictMode>);
                    
                    await new Promise(resolve => setTimeout(resolve, 100));
                    
                    const nodeToCapture = componentWrapper.firstChild;
                    if (!nodeToCapture) {
                        throw new Error("Render edilen component DOM'da bulunamadı.");
                    }

                    // Artık scrollHeight'e gerek kalmadan tam boyutu alabilmeliyiz
                    const dataUrl = await htmlToImage.toPng(nodeToCapture, {
                        pixelRatio: 3,
                        backgroundColor: 'white'
                    });
                    
                    const dosyaAdi = createFileName(tip, detay);
                    
                    if (tip === 'Etiket') {
                        // A5 boyutunda bir canvas oluştur
                        const canvas = document.createElement('canvas');
                        const a5Width = 1748; // yaklaşık 15cm (5.9 inç * 300dpi)
                        const a5Height = 2480; // yaklaşık 21cm (8.3 inç * 300dpi)
                        canvas.width = a5Width;
                        canvas.height = a5Height;
                        
                        // Canvas içerisinde 2D context oluştur
                        const ctx = canvas.getContext('2d');
                        
                        // Beyaz bir zemin ile başla
                        ctx.fillStyle = 'white';
                        ctx.fillRect(0, 0, a5Width, a5Height);
                        
                        // Etiket görselini yükle
                        const img = new Image();
                        await new Promise((resolve, reject) => {
                            img.onload = resolve;
                            img.onerror = reject;
                            img.src = dataUrl;
                        });
                        
                        // Etiketin boyutları (15cm x 12cm) - Boyutu genişletildi
                        const etiketWidth = 1748; // yaklaşık 15cm
                        const etiketHeight = 1300; // yaklaşık 12cm - genişletilmiş yükseklik
                        
                        // Etiketi A5 sayfasının üst kısmına hizala
                        ctx.drawImage(
                            img,
                            0, // X konumu
                            0, // Y konumu (üste dayalı)
                            etiketWidth, // Hedef genişlik
                            etiketHeight // Hedef yükseklik
                        );
                        
                        // A5 formatındaki görseli ekle
                        const finalDataUrl = canvas.toDataURL('image/png');
                        zip.file(dosyaAdi, finalDataUrl.split(',')[1], { base64: true });
                    } else {
                        // Proforma için normal davran
                        zip.file(dosyaAdi, dataUrl.split(',')[1], { base64: true });
                    }

                    root.unmount();
                    geciciRenderAlani.removeChild(componentWrapper);

                } catch (err) {
                    console.error(`[ID: ${id}] döngü içinde hata:`, err);
                }
            }
        } finally {
            document.body.removeChild(geciciRenderAlani);
        }

        // Zip dosyasını oluştur ve indir
        if (Object.keys(zip.files).length > 0) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `toplu_${tip.toLowerCase()}.zip`);
                alert("Toplu indirme tamamlandı!");
            });
        } else {
            alert("Hiçbir dosya oluşturulamadı. Lütfen konsolu kontrol edin.");
        }
    };

    // Tarih input'u değiştiğinde state'i günceller
    const handleTarihChange = (e) => {
        setSeciliTarih(e.target.value);
    };

    const handleModalOpen = (teklifId = null) => {
        setEditingTeklifId(teklifId); // Düzenleme için id'yi, yeni için null'ı ayarla
        setIsModalOpen(true);
    };

    const handleModalClose = (refresh = false, yeniTeklif = null) => {
        setIsModalOpen(false);
        setEditingTeklifId(null); // Modal kapanınca ID'yi temizle
        
        // Backend'den güncel listeyi çek
        if (refresh || yeniTeklif) {
            fetchTeklifler();
        }
    };

    const createFileName = (tip, teklif) => {
        const musteri = teklif.musteri || teklif;
        const telefonSon4 = (musteri.telefon_numarasi || '0000').slice(-4);
        const musteriAdSoyad = (musteri.ad_soyad || 'Isimsiz').replace(/ /g, '_'); // Boşlukları _ ile değiştir
        
        // E-fatura numarası varsa ve Etiket ise doğrudan e-fatura numarasını kullan
        if (tip === 'Etiket' && teklif.parasut_fatura_id) {
            const faturaBilgisi = faturaStatuslari[teklif.parasut_fatura_id];
            
            // Fatura bilgisini debug etmek için ayrıntılı yazdır
            console.log(`DEBUG - Fatura bilgisi inceleniyor (${teklif.id}):`, 
                faturaBilgisi ? JSON.stringify(faturaBilgisi, null, 2) : 'Fatura bilgisi bulunamadı');
            
            // Fatura bilgisi kontrolü - Direkt fatura_no var mı?
            if (faturaBilgisi && faturaBilgisi.fatura_bilgileri && faturaBilgisi.fatura_bilgileri.fatura_no) {
                console.log(`${teklif.id || 'ID yok'} için e-fatura numarası kullanılıyor: ${faturaBilgisi.fatura_bilgileri.fatura_no}`);
                return `${faturaBilgisi.fatura_bilgileri.fatura_no}.png`;
            }
            
            // Alternatif fatura bilgisi kontrolü - Paraşüt API'den farklı yapıda gelebilir
            if (faturaBilgisi && faturaBilgisi.data && faturaBilgisi.data.attributes && 
                faturaBilgisi.data.attributes.invoice_no) {
                console.log(`${teklif.id || 'ID yok'} için alternatif e-fatura numarası kullanılıyor: ${faturaBilgisi.data.attributes.invoice_no}`);
                return `${faturaBilgisi.data.attributes.invoice_no}.png`;
            }
            
            // teklif'in kendi içinde fatura_no varsa
            if (teklif.fatura_no) {
                console.log(`${teklif.id || 'ID yok'} için sipariş içindeki e-fatura numarası kullanılıyor: ${teklif.fatura_no}`);
                return `${teklif.fatura_no}.png`;
            }
        }
        
        // Yoksa eski formatta devam et, ama (Et) prefix'i olmadan
        if (tip === 'Etiket') {
            console.log(`${teklif.id || 'ID yok'} için eski format kullanılıyor (fatura no bulunamadı)`);
            return `${telefonSon4} - ${musteriAdSoyad}.png`;
        }
        
        // Proforma için prefix'i koru
        const prefix = tip === 'Proforma' ? '(Pr)' : '';
        return `${prefix} - ${telefonSon4} - ${musteriAdSoyad}.png`;
    };

    const handleDownloadLabel = async (teklifDetay) => {
        // Hedefimiz artık etiketin kendisi değil, onu saran "kutu".
        const nodeId = `etiket-wrapper-${teklifDetay.id}`;
        const node = document.getElementById(nodeId);

        if (!node) {
            alert("Etiket önizlemesi bulunamadı, indirme işlemi yapılamıyor.");
            return;
        }
        
        // E-fatura numarasını almak için fatura durumunu kontrol et (gerekirse)
        if (teklifDetay.parasut_fatura_id && !faturaStatuslari[teklifDetay.parasut_fatura_id]) {
            try {
                await checkFaturaStatusOtomatik(teklifDetay.parasut_fatura_id);
            } catch (error) {
                console.log("Fatura durumu kontrol edilemedi, dosya adında varsayılan format kullanılacak");
            }
        }

        // A5 boyutunda (15cm x 21cm) bir canvas oluştur
        const canvas = document.createElement('canvas');
        // A5 için piksel boyutları (300 DPI için)
        const a5Width = 1748; // yaklaşık 15cm (5.9 inç * 300dpi)
        const a5Height = 2480; // yaklaşık 21cm (8.3 inç * 300dpi)
        canvas.width = a5Width;
        canvas.height = a5Height;
        
        // Canvas içerisinde 2D context oluştur
        const ctx = canvas.getContext('2d');
        
        // Beyaz bir zemin ile başla
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, a5Width, a5Height);
        
        // Asıl etiket görüntüsünü oluştur
        htmlToImage.toPng(node, { 
            backgroundColor: 'transparent',
            pixelRatio: 3,
        })
        .then((dataUrl) => {
            // Etiket görseli yükle
            const img = new Image();
            img.onload = () => {
                // Etiketin boyutları (15cm x 12cm) - Boyutu genişletildi
                const etiketWidth = 1748; // yaklaşık 15cm
                const etiketHeight = 1300; // yaklaşık 12cm - genişletilmiş yükseklik

                // Etiketi A5 sayfasının üst kısmına hizala
                // Orijinal görüntüyü yeni boyutlarla, ortalayarak çiz
                ctx.drawImage(
                    img, 
                    0, // X konumu
                    0, // Y konumu (üste dayalı)
                    etiketWidth, // Hedef genişlik
                    etiketHeight // Hedef yükseklik
                );
                
                // Yeni oluşturulan A5 formatındaki görseli indir
                const finalDataUrl = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.download = createFileName('Etiket', teklifDetay);
                link.href = finalDataUrl;
                link.click();
            };
            img.src = dataUrl;
        })
        .catch((error) => {
            console.error('Etiket PNG oluşturulurken hata oluştu!', error);
            alert("Etiket indirilirken bir hata oluştu.");
        });
    };

    const filtrelennisTeklifler = teklifler.filter(teklif => {
        if (!aramaTerimi) return true; // Arama terimi yoksa hepsini göster
        const arama = aramaTerimi.toLowerCase();
        const musteriAdi = teklif.musteri?.ad_soyad || teklif.ad_soyad || '';
        const telefon = teklif.musteri?.telefon_numarasi || teklif.telefon_numarasi || '';
        return musteriAdi.toLowerCase().includes(arama) || 
               telefon.includes(arama);
    });

    const handleRowClick = (teklifId) => {
        const yeniAcikId = acikTeklifId === teklifId ? null : teklifId;
        setAcikTeklifId(yeniAcikId);
        if (yeniAcikId !== null) {
            setDetayData(null);
            // Yeni detay yüklenirken fatura kişi bilgisini sıfırla
            setFaturaKisiAdi('');
            
            // DEMO MODE - API çağrısı yerine mevcut teklif listesinden bul
            const teklif = teklifler.find(t => t.id === yeniAcikId);
            if (teklif) {
                // Detay formatına çevir
                const detayFormatli = {
                    id: teklif.id,
                    teklif_no: teklif.teklif_no,
                    tarih: teklif.tarih,
                    musteri: teklif.musteri,
                    teklif_kaynagi: teklif.teklif_kaynagi,
                    odeme_yontemi: teklif.odeme_yontemi,
                    kargo_ucreti: teklif.kargo_ucreti || 0,
                    kapida_odeme_ucreti: teklif.kapida_odeme_ucreti || 0,
                    indirim: teklif.indirim || 0,
                    toplam_bedel: teklif.toplam_bedel,
                    ara_toplam: teklif.ara_toplam || 0,
                    kdv_tutari: teklif.kdv_tutari || 0,
                    has_makine_baskisi: teklif.has_makine_baskisi || false,
                    has_ozel_baskisi: teklif.has_ozel_baskisi || false,
                    sepet: teklif.sepet || [],
                    // EFT durumu için demo değerler
                    odeme_durumu: teklif.odeme_yontemi === 'E' ? 'Ödeme Bekleniyor' : null,
                    odenen_bedel: teklif.odeme_yontemi === 'E' ? 0 : null
                };
                console.log('📋 DEMO DETAY YÜKLENDİ:', detayFormatli);
                setDetayData(detayFormatli);
            }
        }
    }; 

    const handleQueryShipmentStatus = async (takipNo) => {
        setKargoSorguLoading(true);
        setKargoHareketleri([]); // Önceki sonuçları temizle
        try {
            const response = await fetch(`api/kargo-takip/${takipNo}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }
            setKargoHareketleri(data);
        } catch (error) {
            alert(`Kargo durumu sorgulanırken hata: ${error.message}`);
        } finally {
            setKargoSorguLoading(false);
        }
    };

    const handleUpdatePttShipment = (teklifId) => {
        const message = "Sipariş bilgileri güncellenerek PTT için YENİ bir barkod oluşturulacaktır. Eski barkod geçersiz olacaktır. Emin misiniz?";
        const isConfirmed = window.confirm(message);
        if (isConfirmed) {
            // Aslında yeni bir kargo oluşturma işlemini tetikliyoruz.
            handleCreatePttShipment(teklifId);
        }
    };

    const handleCreateParasutInvoice = async (teklifId, ozelFaturaKisiAdi = null) => {
        const isConfirmed = window.confirm('Bu sipariş için Paraşüt\'te fatura taslağı oluşturulacaktır. Emin misiniz?');
        if (!isConfirmed) return;

        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            window.location.href = '/login';
            return;
        }

        try {
            // NOT: Backend'de `/api/teklifler/:id/fatura-olustur` endpoint'ini güncellemek gerekiyor:
            // 1. Request body'den faturaKisiAdi parametresini alıp 
            // 2. Paraşüt API'ye gönderilen contact name bilgisini bu değerle değiştirmek gerekli
            // Örnek: if (req.body.faturaKisiAdi) contact.name = req.body.faturaKisiAdi;
            const response = await fetch(`/api/teklifler/${teklifId}/fatura-olustur`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    faturaKisiAdi: ozelFaturaKisiAdi
                })
            });

            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }

            const data = await response.json();
            if (!response.ok) {
                const hataMesaji = data?.hata || `Sunucu hatası (Kod ${response.status})`;
                throw new Error(hataMesaji);
            }

            alert(`${data.mesaj}\nFatura ID: ${data.faturaId}\nDurum: ${data.faturaDurumu}`);
            handleRowClick(teklifId);
            
            // Yeni fatura oluşturulduktan sonra otomatik durumu kontrol et
            if (data.faturaId) {
                setTimeout(() => {
                    checkFaturaStatusOtomatik(data.faturaId);
                }, 1000); // 1 saniye bekle
            }

        } catch (error) {
            console.error("Paraşüt Faturası oluşturulurken hata:", error);
            alert(`Fatura oluşturulamadı:\n${error.message}`);
        }
    };

    const handleUpdateParasutInvoice = async (teklifId) => {
        const isConfirmed = window.confirm('Bu siparişin Paraşüt\'teki faturası güncellenecektir. Emin misiniz?');
        if (!isConfirmed) return;

        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            return;
        }

        try {
            const response = await fetch(`api/teklifler/${teklifId}/fatura-guncelle`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            
            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }

            alert(`${data.mesaj}\nFatura ID: ${data.faturaId}\nYeni Durum: ${data.faturaDurumu}`);
            handleRowClick(teklifId); // Detayları yenile

        } catch (error) {
            console.error("Paraşüt Faturası güncellenirken hata:", error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleDownloadInvoicePdf = async (faturaId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                return;
            }

            // PDF indirme isteği
            const response = await fetch(`api/faturalar/${faturaId}/download`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.hata || 'PDF indirilemedi');
            }

            // PDF blob'unu oluştur
            const blob = await response.blob();
            
            // PDF'i indir
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `fatura_${faturaId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("PDF indirirken hata:", error);
            alert(`PDF indirilemedi: ${error.message}`);
        }
    };

    const handleCheckInvoiceStatus = async (faturaId, teklifId) => {
        // Loading state'i başlat
        setResmilestirLoading(prev => ({ ...prev, [faturaId]: true }));

        try {
            const response = await fetch(`api/faturalar/${faturaId}/durum`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            if (!response.ok) { throw new Error(data.hata); }

            if (data.is_finalized) {
                // Resmileşmiş fatura bilgilerini göster
                const faturaBilgi = data.fatura_bilgileri;
                let mesaj = "✅ FATURA RESMİLEŞTİRİLMİŞ!\n\n";
                mesaj += `Fatura No: ${faturaBilgi.fatura_no}\n`;
                mesaj += `Durum: ${faturaBilgi.durum}\n`;
                mesaj += `Tutar: ${faturaBilgi.tutar} ${faturaBilgi.para_birimi}\n`;
                if (faturaBilgi.duzenlenme_tarihi) {
                    mesaj += `Düzenlenme Tarihi: ${faturaBilgi.duzenlenme_tarihi}\n`;
                }
                
                alert(mesaj);
                
                // Veritabanındaki durumu da güncelle
                const ilgili_teklif = teklifler.find(s => s.id === teklifId);
                if (ilgili_teklif && ilgili_teklif.parasut_fatura_durumu !== 'issued') {
                    handleRowClick(teklifId); // Detayları yenile
                }
            } else {
                // Henüz resmileşmemiş
                alert(`❌ ${data.mesaj}\n\nParaşüt panelinden manuel resmileştirme yapılması gerekiyor.`);
            }

        } catch (error) {
            console.error("Fatura durumu kontrol edilirken hata:", error);
            alert(`Hata: ${error.message}`);
        } finally {
            // Loading state'i bitir
            setResmilestirLoading(prev => ({ ...prev, [faturaId]: false }));
        }
    };
    
    // Tarih filtresini temizler
    const handleFiltreyiTemizle = () => {
        setSeciliTarih('');
    };
    
    const handleteklifDuzenle = (teklifId) => {
        if (isButtonDisabled()) return;
        // navigate(`/teklif/duzenle/${teklifId}`); // ESKİ HALİ
        handleModalOpen(teklifId); // YENİ HALİ
    };

    const handleCreatePttShipment = async (teklifId) => {
        if (isButtonDisabled()) return;
        // Kullanıcıdan onay alalım
        const isConfirmed = window.confirm('Bu sipariş için PTT Kargo kaydı oluşturulacaktır. Emin misiniz?');
        if (!isConfirmed) {
            return;
        }

        try {
            const response = await fetch(`api/teklifler/${teklifId}/kargo-olustur`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası oluştu.');
            }

            alert(`${data.mesaj}\nTakip No: ${data.kargoTakipNo}`);
            
            // Başarılı olduktan sonra, yeni takip numarasını görmek için detay verisini yenileyelim
            handleRowClick(teklifId);

        } catch (error) {
            console.error("PTT Kargo oluşturulurken hata:", error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleDownloadJpg = async (teklifDetay) => { // Fonksiyonu async olarak işaretle
        const proformaNodeId = `proforma-${teklifDetay.id}`;
        const tableContainerNodeId = `proforma-table-container-${teklifDetay.id}`;

        const proformaNode = document.getElementById(proformaNodeId);
        const tableContainerNode = document.getElementById(tableContainerNodeId);

        if (!proformaNode || !tableContainerNode) {
            console.error("İndirilecek elementler bulunamadı.");
            alert("Önizleme alanı bulunamadı, indirme işlemi yapılamıyor.");
            return;
        }

        // 1. Orijinal stilleri sakla
        const originalProformaHeight = proformaNode.style.height;
        const originalTableContainerOverflow = tableContainerNode.style.overflowY;

        // 2. Fotoğraf çekimi için stilleri geçici olarak değiştir
        proformaNode.style.height = 'auto'; // Ana container'ın yüksekliğini otomatik yap
        tableContainerNode.style.overflowY = 'visible'; // Kaydırma çubuğunu kaldır

        try {
            // 3. Görüntüyü oluşturmayı bekle
            const dataUrl = await htmlToImage.toJpeg(proformaNode, {
                quality: 1,
                backgroundColor: '#ffffff',
                pixelRatio: 3
            });

            // 4. İndirme linkini oluştur ve tıkla
            const link = document.createElement('a');
            link.download = createFileName('Proforma', teklifDetay);
            link.href = dataUrl;
            link.click();

        } catch (error) {
            console.error('Görüntü oluşturulurken hata oluştu!', error);
            alert("Önizleme indirilirken bir hata oluştu.");
        } finally {
            // 5. NE OLURSA OLSUN stilleri orijinal haline geri getir
            proformaNode.style.height = originalProformaHeight;
            tableContainerNode.style.overflowY = originalTableContainerOverflow;
        }
    };

    const handleSendWhatsapp = async () => {
        // İki hedef elementin de ID'lerini alıyoruz
        const proformaNodeId = `proforma-${detayData.id}`;
        const tableContainerNodeId = `proforma-table-container-${detayData.id}`;

        const proformaNode = document.getElementById(proformaNodeId);
        const tableContainerNode = document.getElementById(tableContainerNodeId);
        const phoneNumber = proformaTel.replace(/[^0-9]/g, '');

        // Elementlerin varlığını kontrol et
        if (!proformaNode || !tableContainerNode) {
            alert("Önizleme alanı veya içeriği bulunamadı.");
            return;
        }
        if (!phoneNumber) {
            alert("Gönderilecek telefon numarası boş.");
            return;
        }

        // 1. Orijinal stilleri daha sonra geri yüklemek için sakla
        const originalProformaHeight = proformaNode.style.height;
        const originalTableContainerOverflow = tableContainerNode.style.overflowY;

        try {
            // 2. Fotoğraf çekimi için stilleri geçici olarak değiştir
            proformaNode.style.height = 'auto';
            tableContainerNode.style.overflowY = 'visible';

            // 3. Resmi PNG formatında bir Blob olarak oluştur
            const blob = await htmlToImage.toBlob(proformaNode, {
                pixelRatio: 3,
                backgroundColor: '#ffffff',
                cacheBust: true
            });

            if (!blob) {
                throw new Error("Görsel (blob) oluşturulamadı.");
            }

            // 4. Resmi panoya PNG formatında kopyala
            await navigator.clipboard.write([
                new ClipboardItem({ 'image/png': blob })
            ]);
            
            // 5. WhatsApp sohbet linkini aç (Herkes için çalışan güvenli yöntem)
            window.location.href = `whatsapp://send?phone=90${phoneNumber}`;
            
            // Uyarı mesajını kaldırdık - direkt olarak WhatsApp açılacak

        } catch (error) {
            console.error("Gönderme işlemi sırasında detaylı hata:", error);
            alert("Görsel oluşturulurken veya paylaşılırken bir hata oluştu. Detaylar için konsolu kontrol edin.");
        } finally {
            // 7. NE OLURSA OLSUN stilleri orijinal haline geri getir
            proformaNode.style.height = originalProformaHeight;
            tableContainerNode.style.overflowY = originalTableContainerOverflow;
        }
    };

     const handleTopluBarkodAl = async () => {
        if (!seciliTarih) {
            alert("Lütfen geçerli bir tarih seçin.");
            return;
        }
        
        // Seçili sipariş kontrolü
        if (seciliTeklifler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        const isConfirmed = window.confirm(`Seçili ${seciliTeklifler.length} sipariş için PTT'den takip numarası alınacaktır. Bu işlem biraz zaman alabilir. Emin misiniz?`);
        if (!isConfirmed) return;

        alert("İşlem başlatıldı, lütfen bekleyin...");

        try {
            const response = await fetch('/api/teklifler/toplu-barkod-olustur', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    teklifIds: seciliTeklifler 
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            // Sonuç özetini kullanıcıya göster
            let sonucMesaji = data.mesaj;
            if (data.hatalar && data.hatalar.length > 0) {
                sonucMesaji += "\n\nHatalar:\n" + data.hatalar.join("\n");
            }
            alert(sonucMesaji);

            // İşlem bittikten sonra listeyi yenile
            fetchTeklifler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
        }
    };

    const handleTopluFaturaGonder = async () => {
        if (!seciliTarih) {
            alert("Lütfen geçerli bir tarih seçin.");
            return;
        }
        
        // Seçili sipariş kontrolü
        if (seciliTeklifler.length === 0) {
            alert("Lütfen en az bir sipariş seçin.");
            return;
        }

        const isConfirmed = window.confirm(`Seçili ${seciliTeklifler.length} sipariş için Paraşüt'te fatura oluşturulacaktır. Bu işlem biraz zaman alabilir. Emin misiniz?`);
        if (!isConfirmed) return;

        alert("İşlem başlatıldı, lütfen bekleyin...");

        try {
            // Sadece ID'leri göndererek dairesel referansları önleyelim
            const teklifIdleri = [...seciliTeklifler];
            
            const response = await fetch('/api/teklifler/toplu-fatura-olustur', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ 
                    teklifIds: teklifIdleri
                })
            });

            if (response.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Bilinmeyen bir sunucu hatası.');
            }

            // Sonuç özetini kullanıcıya göster
            let sonucMesaji = data.mesaj;
            if (data.basarili_teklifler && data.basarili_teklifler.length > 0) {
                sonucMesaji += `\n\nBaşarılı Siparişler (${data.basarili_teklifler.length}):`;
                data.basarili_teklifler.forEach(teklif => {
                    sonucMesaji += `\n- Sipariş #${teklif.teklif_no}: Fatura ID ${teklif.fatura_id}`;
                });
            }
            
            if (data.hatalar && data.hatalar.length > 0) {
                sonucMesaji += `\n\nHatalar (${data.hatalar.length}):`;
                data.hatalar.forEach(hata => {
                    sonucMesaji += `\n- ${hata}`;
                });
            }
            
            alert(sonucMesaji);

            // İşlem bittikten sonra listeyi yenile
            fetchTeklifler();

        } catch (error) {
            alert(`Bir hata oluştu: ${error.message}`);
        }
    };

    // handleA5Print fonksiyonu kaldırıldı (artık kullanılmıyor)

    const getDurumRengi = (durum) => {
        switch (durum) {
            case 'Tamamı Ödendi': return '#28a745'; // Yeşil
            case 'Kısmen Ödendi': return '#fd7e14'; // Turuncu
            case 'Ödenmedi': return '#dc3545'; // Kırmızı
            default: return 'black';
        }
    };
    
    const handleSaveNote = async () => {
        if (!detayData) {
            alert("Teklif bilgisi bulunamadı.");
            return;
        }

        try {
            const response = await fetch(`/api/teklifler/${detayData.id}/not`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ notlar: musteriNotu })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Not kaydedilirken bir hata oluştu.');
            }
            alert(data.mesaj || 'Not başarıyla güncellendi!');
        } catch (error) {
            console.error("Not kaydedilirken hata:", error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleteklifSil = (teklifId) => {
        const isConfirmed = window.confirm(`#${teklifId} numaralı teklifi kalıcı olarak silmek istediğinizden emin misiniz?\n\n⚠️ Bu işlem geri alınamaz!`);
        if (isConfirmed) {
            // Backend'e DELETE isteği gönder
            fetch(`${baseURL}/api/teklifler/${teklifId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => {
                        throw new Error(err.hata || 'Teklif silinemedi');
                    });
                }
                return res.json();
            })
            .then(data => {
                console.log('✅ Teklif silindi:', data);
                alert('✅ Teklif başarıyla silindi.');
                // Listeyi yenile
                fetchTeklifler();
            })
            .catch(err => {
                console.error('❌ Teklif silme hatası:', err);
                alert('Teklif silinirken hata oluştu: ' + err.message);
            });
        }
    };

    const handleTeklifSipariseCevir = async (teklifId) => {
        // Teklifi listeden bul
        const teklif = teklifler.find(t => t.id === teklifId);
        if (!teklif) {
            alert('Teklif bulunamadı!');
            return;
        }

        // Tarih seçimi için modal aç
        openTarihModal(async (seciliTarih) => {
            const isConfirmed = window.confirm(
                `Bu teklif ${seciliTarih} tarihine sipariş olarak kaydedilecektir.\n\nEmin misiniz?`
            );
            if (!isConfirmed) return;

        try {
            // Sipariş API'sine gönderilecek veri formatı (backend'in beklediği format)
            const siparisData = {
                musteri: {
                    id: teklif.musteri.id,
                    ad_soyad: teklif.musteri.ad_soyad,
                    telefon: teklif.musteri.telefon_numarasi
                },
                siparis: {
                    siparis_kaynagi: teklif.teklif_kaynagi,
                    odeme_yontemi: teklif.odeme_yontemi,
                    kargo_ucreti: teklif.kargo_ucreti || 0,
                    kapida_odeme_ucreti: teklif.kapida_odeme_ucreti || 0,
                    indirim: teklif.indirim || 0,
                    toplam_bedel: teklif.toplam_bedel || 0,
                    ara_toplam: teklif.ara_toplam || 0,
                    kdv_tutari: teklif.kdv_tutari || 0,
                    siparis_tarihi: seciliTarih  // Kullanıcının seçtiği tarih
                },
                sepet: teklif.sepet.map(item => ({
                    id: item.id || item.urun_id || null,
                    urun_adi: item.urun_adi,
                    adet: parseInt(item.adet) || 0,
                    fiyat: parseFloat(item.fiyat) || 0
                }))
            };

            console.log('📋 Siparişe çevrilecek teklif:', siparisData);
            
            // Sipariş oluştur API çağrısı
            const response = await fetch('/api/siparisler/yeni', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(siparisData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.hata || 'Sipariş oluşturulamadı');
            }

            const data = await response.json();
            
            alert(`✅ Teklif #${teklif.teklif_no} başarıyla siparişe çevrildi!\n\nSipariş No: ${data.siparis_no || data.id}\n\nTeklif sayfasında kalmaya devam edecek.\nSipariş Listesi sayfasında da görüntüleyebilirsiniz.`);
            
            // Teklif listeden KALDIRILMAYACAK - sadece bilgi mesajı gösterilecek

        } catch (error) {
            console.error('Teklif siparişe çevrilirken hata:', error);
            alert(`❌ Hata: ${error.message}`);
        }
        });
    };

    const handleTopluSipariseCevir = async () => {
        if (seciliTeklifler.length === 0) {
            alert('Lütfen en az bir teklif seçin.');
            return;
        }

        // Tarih seçimi için modal aç
        openTarihModal(async (seciliTarih) => {
            const isConfirmed = window.confirm(
                `Seçili ${seciliTeklifler.length} teklif ${seciliTarih} tarihine sipariş olarak kaydedilecektir.\n\nEmin misiniz?`
            );
            if (!isConfirmed) return;

        let basariliSayisi = 0;
        let hataliSayisi = 0;
        const hataMesajlari = [];

        for (const teklifId of seciliTeklifler) {
            let teklif = null;
            try {
                teklif = teklifler.find(t => t.id === teklifId);
                if (!teklif) {
                    hataliSayisi++;
                    hataMesajlari.push(`#${teklifId}: Teklif bulunamadı`);
                    continue;
                }

                const siparisData = {
                    musteri: {
                        id: teklif.musteri.id,
                        ad_soyad: teklif.musteri.ad_soyad,
                        telefon: teklif.musteri.telefon_numarasi
                    },
                    siparis: {
                        siparis_kaynagi: teklif.teklif_kaynagi,
                        odeme_yontemi: teklif.odeme_yontemi,
                        kargo_ucreti: teklif.kargo_ucreti || 0,
                        kapida_odeme_ucreti: teklif.kapida_odeme_ucreti || 0,
                        indirim: teklif.indirim || 0,
                        toplam_bedel: teklif.toplam_bedel || 0,
                        ara_toplam: teklif.ara_toplam || 0,
                        kdv_tutari: teklif.kdv_tutari || 0,
                        siparis_tarihi: seciliTarih  // Kullanıcının seçtiği tarih
                    },
                    sepet: teklif.sepet.map(item => ({
                        id: item.id || item.urun_id || null,
                        urun_adi: item.urun_adi,
                        adet: parseInt(item.adet) || 0,
                        fiyat: parseFloat(item.fiyat) || 0
                    }))
                };

                const response = await fetch('/api/siparisler/yeni', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify(siparisData)
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.hata || 'Sipariş oluşturulamadı');
                }

                basariliSayisi++;

            } catch (error) {
                hataliSayisi++;
                const teklifNo = teklif ? teklif.teklif_no : teklifId;
                hataMesajlari.push(`#${teklifNo}: ${error.message}`);
            }
        }

        // Sonuç mesajı
        let sonucMesaji = `İşlem tamamlandı!\n\n✅ Başarılı: ${basariliSayisi}\n❌ Hatalı: ${hataliSayisi}`;
        
        if (hataMesajlari.length > 0) {
            sonucMesaji += `\n\nHatalar:\n${hataMesajlari.join('\n')}`;
        }

        alert(sonucMesaji);
        
        // Teklifler listeden KALDIRILMAYACAK - sadece seçimleri temizle
        // Seçimleri temizle
        setseciliTeklifler([]);
        });
    };

    // Renk kodları ve stiller
    const kaynakRenkleri = { W: '#25d366', S: '#3783c2', R: '#f4bf4a' };
    const odemeRenkleri = { K: '#17bebb', E: '#6761a8', O: '#2c6184', D: '#bb999c', B: '#a32e68' };
    const statusIconStyle = {
        width: '20px', height: '20px', borderRadius: '50%', color: 'white', display: 'inline-flex', 
        alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold',
    };

    // Detay bandı için ortak stiller
    const detailStyles = {
        column: {
            flex: 1,
            padding: '15px',
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column',
            fontfamily: 'poppins',
            gap: '20px',
        },
        title: {
            fontWeight: '600',
            fontSize: '13px',
            color: '#555',
            textTransform: 'uppercase',
            borderBottom: '1px solid #eee',
            paddingBottom: '10px',
            fontfamily: 'poppins'
        },

        button: {
            padding: '8px 16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: '#f7f7f7',
            cursor: 'pointer',
            textAlign: 'center',
            fontSize: '13px',
            fontfamily: 'poppins'
        },

        primaryButton: {
            padding: '10px 16px',
            border: 'none',
            borderRadius: '4px',
            background: '#28a745', // Yeşil renk
            color: 'white',
            cursor: 'pointer',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            fontfamily: 'poppins'
        },
        input: {
            width: '100%',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
            fontfamily: 'poppins'
        },
        noteArea: {
            width: '100%',
            minHeight: '80px',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
            fontFamily: 'poppins',
            fontSize: '13px',
        },
        actionGroup: {
            display: 'flex',
            alignItems: 'center',
            fontfamily: 'poppins',
            gap: '10px'
        }
    };

     const handleConfirmUpload = async () => {
        if (!selectedFile) return;

        setIsCsvModalOpen(false);
        setUploadStatus('Yükleniyor, lütfen bekleyin...');
        
        console.log('📤 CSV upload başlatılıyor...');
        console.log('📄 Seçili dosya:', selectedFile);
        
        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            console.log('🌐 Backend istek gonderiliyor...');
            const response = await fetch('/api/upload-csv', {
                method: 'POST',
                body: formData,
            });
            
            console.log('📡 Response status:', response.status);
            console.log('📡 Response ok:', response.ok);
            
            const result = await response.json();
            console.log('📊 Response data:', result);
            
            setUploadStatus(response.ok ? result.message : `Hata: ${result.message}`);
            if (response.ok) {
                setTimeout(() => window.location.reload(), 2000); // 2 saniye sonra sayfayı yenile
            }
        } catch (error) {
            console.error('❌ CSV upload hatası:', error);
            setUploadStatus(`Yükleme sırasında bir ağ hatası oluştu: ${error.message}`);
        } finally {
            if(fileInputRef.current) fileInputRef.current.value = "";
            setSelectedFile(null);
        }
    };
    
    // --- Onay Ekranındaki "İptal" Butonunun Fonksiyonu ---
    const handleCancelUpload = () => {
        setIsCsvModalOpen(false);
        setSelectedFile(null);
        if(fileInputRef.current) fileInputRef.current.value = "";
    };
    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            
            {/* DEMO UYARI BANNER */}
            <div style={{
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                padding: '12px',
                marginBottom: '20px',
                color: '#856404',
                textAlign: 'center',
                fontSize: '14px',
                flexShrink: 0
            }}>
                <strong>📋 Teklif Modu:</strong> Bu sayfada gerçek sipariş oluşturulmaz ve stoklar etkilenmez.
            </div>

            {/* --- İSTEDİĞİNİZ ŞEKİLDE GÜNCELLENMİŞ ÜST BAR --- */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <style>{`
                .teklif-satiri {
                    transition: all 0.2s ease-in-out;
                }
                .teklif-satiri:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                    position: relative;
                }
                `}</style>
                
                {/* Sol Taraf: Tarih Filtresi ve Butonlar */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label style={{ fontWeight: '500', fontFamily: 'poppins' }}>Ay Seçiniz:</label>
                        <input 
                            type="month" 
                            value={seciliTarih}
                            onChange={(e) => setSeciliTarih(e.target.value)}
                            style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins' }} 
                        />
                    </div>
                    
                    {/* Özdeş Butonlar */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {/* Yeni Teklif Butonu */}
                        <button 
                            onClick={() => { !isButtonDisabled() && handleModalOpen(); }} 
                            disabled={isButtonDisabled()}
                            style={{ 
                                padding: '5px 15px', 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '8px', 
                                cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px', 
                                fontFamily: 'poppins',
                                background: '#f8f8f8',
                                fontSize: '13px',
                                opacity: isButtonDisabled() ? '0.5' : '1'
                            }}>
                            <img src={PlusIcon} alt="Yeni" style={{ height: '14px' }} />
                            <span>Yeni Teklif</span>
                        </button>
                    </div>
                    {uploadStatus && (
                        <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            marginTop: '5px',
                            padding: '5px 10px',
                            background: '#f0f0f0',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontStyle: 'italic',
                            color: '#666',
                            zIndex: 10
                        }}>
                            {uploadStatus}
                        </div>
                    )}

                {/* --- CSV Upload Onay Ekranı (Modal) --- */}
                {isCsvModalOpen && (
                    <div className="modal-overlay" style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}}>
                        <div className="modal-content" style={{backgroundColor: 'white', padding: '20px', borderRadius: '5px', textAlign: 'center', fontFamily: 'poppins'}}>
                            <p style={{marginBottom: '15px', fontSize: '14px'}}>Seçilen CSV dosyasında <strong>{orderCount}</strong> adet benzersiz sipariş bulundu.</p>
                            <p style={{marginBottom: '20px', fontSize: '14px'}}>Siparişler panele yüklensin mi?</p>
                            <div style={{display: 'flex', justifyContent: 'center', gap: '10px'}}>
                                <button 
                                    onClick={handleConfirmUpload} 
                                    style={{
                                        padding: '5px 15px', 
                                        background: '#f8f8f8', 
                                        fontFamily: 'poppins', 
                                        alignItems: 'center', 
                                        display: 'flex', 
                                        border: '1px solid #28a745', 
                                        borderRadius: '4px', 
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        color: '#28a745'
                                    }}
                                >
                                    <span>Onayla ve Yükle</span>
                                </button>
                                <button 
                                    onClick={handleCancelUpload} 
                                    style={{
                                        padding: '5px 15px', 
                                        background: '#f8f8f8', 
                                        fontFamily: 'poppins', 
                                        alignItems: 'center', 
                                        display: 'flex', 
                                        border: '1px solid #6c757d', 
                                        borderRadius: '4px', 
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        color: '#6c757d'
                                    }}
                                >
                                    <span>İptal</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                    <input 
                        type="text" 
                        placeholder="Müşteri veya Tel No Ara..."
                        value={aramaTerimi}
                        onChange={(e) => setAramaTerimi(e.target.value)}
                        style={{ 
                            padding: '6px', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px',
                            width: '400px',
                            fontFamily: 'poppins'
                        }}
                    />
                </div>

                {/* Sağ Taraf: Toplu İşlemler */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <button 
                        onClick={handleTopluSipariseCevir} 
                        disabled={seciliTeklifler.length === 0 || isButtonDisabled()} 
                        style={{
                            padding: '4px 12px', 
                            fontFamily: 'poppins', 
                            alignItems: 'center', 
                            display: 'flex', 
                            gap: '8px',
                            background: '#f8f8f8',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            opacity: seciliTeklifler.length === 0 || isButtonDisabled() ? '0.5' : '1',
                            cursor: seciliTeklifler.length === 0 || isButtonDisabled() ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <img src={TickIcon} alt="Siparişe Çevir" style={{ height: '14px', filter: 'invert(45%) sepia(75%) saturate(450%) hue-rotate(75deg) brightness(95%) contrast(90%)' }} />
                        <span>Siparişe Çevir</span>
                    </button>
                    <button 
                        onClick={() => handleTopluIndir('Proforma')} 
                        disabled={seciliTeklifler.length === 0 || isButtonDisabled()} 
                        style={{
                            padding: '4px 12px', 
                            fontFamily: 'poppins', 
                            alignItems: 'center', 
                            display: 'flex', 
                            gap: '8px',
                            background: '#f8f8f8',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            opacity: seciliTeklifler.length === 0 || isButtonDisabled() ? '0.5' : '1',
                            cursor: seciliTeklifler.length === 0 || isButtonDisabled() ? 'not-allowed' : 'pointer'
                        }}
                    >
                        <img src={DownloadIcon} alt="Proformalar" style={{ height: '14px' }} />
                        <span>Proformalar</span>
                    </button>
                </div>
            </div>

            {/* Seçili Sipariş Sayısı - Fixed Popup */}
            {seciliTeklifler.length > 0 && (
                <div style={{ 
                    position: 'fixed',
                    bottom: '30px', // Alt köşe
                    right: '30px',
                    zIndex: 1000,
                    backgroundColor: '#ffffff',
                    border: '1px solid #000000', // İnce siyah çerçeve
                    borderRadius: '6px', // Biraz küçültüldü
                    padding: '8px 12px', // Padding küçültüldü
                    fontSize: '14px',
                    color: '#000000', // Siyah font
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    minWidth: '180px', // Biraz küçültüldü
                    textAlign: 'center',
                    animation: 'slideInFromRight 0.3s ease-out'
                }}>
                    {seciliTeklifler.length} Adet Sipariş Seçildi
                </div>
            )}

            {/* CSS Animation (inline style tag) */}
            <style>{`
                @keyframes slideInFromRight {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `}</style>

            {/* Sipariş Tablosu */}
            <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '13px' }}>
                <thead>
                    <tr style={{ background: '#E5E5E5', height: '35px' }}>
                        <th style={{ padding: '11px', width: '30px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>
                            <input 
                                type="checkbox"
                                onChange={handleTumunuSec}
                                checked={filtrelennisTeklifler.length > 0 && seciliTeklifler.length === filtrelennisTeklifler.length}
                            />
                        </th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '500', width: '20px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Sıra</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '500', width: '90px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Telefon</th>
                        <th style={{ width: '180px', padding: '11px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ad Soyad</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '500', width: '700px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Adres</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '500', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İl</th>
                        <th style={{ padding: '11px', textAlign: 'left', fontWeight: '500', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İlçe</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '500', width: '120px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Tutar</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '500', width: '100px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Durum</th>
                        <th style={{ padding: '11px', textAlign: 'center', fontWeight: '500', width: '40px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                        {filtrelennisTeklifler.length > 0 ? (
                            filtrelennisTeklifler.map((teklif, index) => (
                                <React.Fragment key={teklif.id}>
                                    
                                    {/* Tüm özellikler tek ve doğru <tr> etiketinin içinde */}
                                    <tr 
                                        className="teklif-satiri" 
                                        style={{ 
                                            backgroundColor: 
                                                teklif.kargo_durumu === 'Beklemede' ? '#fff4ccff' : 
                                                teklif.kargo_durumu === 'Acil' ? '#ffeeee' :
                                                '#ffffff',
                                            borderBottom: '1px solid #eee',
                                            cursor: 'pointer',
                                            borderLeft: 
                                                teklif.kargo_durumu === 'Beklemede' ? '4px solid #ffc107' : 
                                                teklif.kargo_durumu === 'Acil' ? '4px solid #dc3545' :
                                                'none'
                                        }} 
                                        onClick={() => handleRowClick(teklif.id)}
                                    > 
                                        {/* Seçim Kutusu */}
                                        <td style={{ padding: '12px', textAlign: 'center', width: '30px' }} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox"
                                                checked={seciliTeklifler.includes(teklif.id)}
                                                onChange={() => handleSecim(teklif.id)}
                                            />
                                        </td>
                                    <td style={{ padding: '11px', textAlign: 'center', fontWeight: '500', fontSize: '12px', width: '20px' }}>{index + 1}</td>
                                    <td style={{ padding: '11px', width: '90px' }}>{teklif.musteri?.telefon_numarasi || teklif.telefon_numarasi || '-'}</td>
                                    <td style={{ padding: '11px' }}>{teklif.musteri?.ad_soyad || teklif.ad_soyad || '-'}</td>
                                    <td style={{ padding: '11px', width: '500px' }}>{teklif.musteri?.adres || teklif.adres || '-'}</td>
                                    <td style={{ padding: '11px', width: '120px' }}>{teklif.musteri?.il || teklif.il || '-'}</td>
                                    <td style={{ padding: '11px', width: '120px' }}>{teklif.musteri?.ilce || teklif.ilce || '-'}</td>
                                    <td style={{ padding: '11px', textAlign: 'center', fontWeight: '400', width: '100px' }}>{(teklif.toplam_bedel || 0).toFixed(2)} ₺</td>
                                    <td style={{ padding: '11px', textAlign: 'center', width: '100px' }}>
                                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                                            <span style={{ ...statusIconStyle, background: kaynakRenkleri[teklif.teklif_kaynagi] }}>{teklif.teklif_kaynagi}</span>
                                            <span style={{ ...statusIconStyle, background: odemeRenkleri[teklif.odeme_yontemi] }}>{teklif.odeme_yontemi}</span>
                                            <span title="Makine Baskısı" style={{ ...statusIconStyle, background: teklif.has_makine_baskisi ? '#93D82F' : '#F4885A' }}><img src={teklif.has_makine_baskisi ? TickIcon : CrossIcon} alt="Durum" style={{ height: '12px', width: '12px' }} /></span>
                                            <span title="Özel Baskı" style={{ ...statusIconStyle, background: teklif.has_ozel_baskisi ? '#93D82F' : '#F4885A' }}><img src={teklif.has_ozel_baskisi ? TickIcon : CrossIcon} alt="Durum" style={{ height: '12px', width: '12px' }} /></span>
                                            {/* Fatura Durumu İndikatörü */}
                                            {teklif.parasut_fatura_id && (
                                                <span 
                                                    title={faturaStatuslari[teklif.parasut_fatura_id]?.is_finalized ? 'Fatura Resmileşti' : 'Fatura Oluşturuldu'}
                                                    style={{ 
                                                        ...statusIconStyle, 
                                                        background: faturaStatuslari[teklif.parasut_fatura_id]?.is_finalized ? '#28a745' : '#ffc107',
                                                        color: 'white',
                                                        fontWeight: 'bold', 
                                                        fontSize: '11px', 
                                                        width: '20px', 
                                                        height: '20px', 
                                                        borderRadius: '50%', 
                                                        display: 'inline-flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center' 
                                                    }}
                                                >
                                                    {faturaStatuslari[teklif.parasut_fatura_id]?.is_finalized ? '✓' : 'F'}
                                                </span>
                                            )}
                                            {teklif.kargo_durumu === 'Beklemede' && (
                                                <span style={{ ...statusIconStyle, background: '#ffc107', color: 'black', 
                                                    fontWeight: 'bold', fontSize: '13px', width: '20px', height: '20px', borderRadius: '50%', display: 'inline-flex', 
                                                    alignItems: 'center', justifyContent: 'center', }}>B</span>
                                            )}
                                            {teklif.kargo_durumu === 'Acil' && (
                                                <span style={{ ...statusIconStyle, background: '#dc3545', color: 'white', 
                                                    fontWeight: 'bold', fontSize: '13px', width: '20px', height: '20px', borderRadius: '50%', display: 'inline-flex', 
                                                    alignItems: 'center', justifyContent: 'center', }}>A</span>
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center', width: '40px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); handleTeklifSipariseCevir(teklif.id); }}
                                                title="Siparişe Çevir"
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img src={TickIcon} alt="Siparişe Çevir" style={{ width: '16px', height: '16px', filter: 'invert(45%) sepia(75%) saturate(450%) hue-rotate(75deg) brightness(95%) contrast(90%)' }} />
                                            </button>
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); handleteklifDuzenle(teklif.id); }} 
                                                title="Düzenle"
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img src={EditIcon} alt="Düzenle" style={{ width: '15px', height: '15px' }} />
                                            </button>
                                            <button 
                                                onClick={(e) => { e.stopPropagation(); handleteklifSil(teklif.id); }}
                                                title="Sil"
                                                style={{ 
                                                    background: 'none', 
                                                    border: 'none', 
                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                    opacity: isButtonDisabled() ? '0.5' : '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px'
                                                }}
                                                disabled={isButtonDisabled()}
                                            >
                                                <img src={DeleteIcon} alt="Sil" style={{ width: '18px', height: '18px' }} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                
                                {/* YENİ TASARIM: 2. Açılır Detay Bandı Satırı (Koşullu) */}
                                {acikTeklifId === teklif.id && (
                                    <tr className="detay-bandi">
                                        <td colSpan="10" style={{ padding: '10px', background: '#f2f4f7' }}>
                                            {!detayData ? (
                                                <p>Sipariş detayları yükleniyor...</p>
                                            ) : (
                                                <div style={{ display: 'flex', gap: '20px', fontFamily: 'Poppins' }}>
                                                    
                                                    {/* SÜTUN 1: Sipariş Formu (Proforma) */}
                                                    <div style={detailStyles.column}>
                                                        <h3 style={detailStyles.title}>SİPARİŞ FORMU (PROFORMA)</h3>
                                                        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                                                            
                                                            {/* Sol Taraf: Proforma Önizlemesi */}
                                                            <ProformaPreview detayData={detayData} />

                                                            {/* Sağ Taraf: İşlem Paneli */}
                                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                                                <div style={detailStyles.actionGroup}>
                                                                <button 
                                                                    onClick={() => handleDownloadJpg(detayData)}
                                                                    style={{
                                                                        width: '90px', height: '27px', background: '#F8F8F8', borderRadius: '8px',
                                                                        border: '1px solid #ccc', 
                                                                        cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', 
                                                                        padding: '0 20px', fontWeight: '500', 
                                                                        display: 'flex', alignItems: 'center', gap: '5px',
                                                                        opacity: isButtonDisabled() ? '0.5' : '1'
                                                                    }}
                                                                    disabled={isButtonDisabled()}
                                                                >
                                                                        <img src={DownloadIcon} alt="Ekle" style={{ height: '16px' }} /> <span>İndir</span>
                                                                </button>
                                                                <button 
                                                                    type="button" 
                                                                    onClick={handleSendWhatsapp} 
                                                                    disabled={isButtonDisabled()}
                                                                    style={{
                                                                        width: '90px', 
                                                                        height: '27px', 
                                                                        background: '#F8F8F8', 
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ccc', 
                                                                        cursor: isButtonDisabled() ? 'not-allowed' : 'pointer', 
                                                                        padding: '0 12px', 
                                                                        fontWeight: '500', 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        gap: '5px',
                                                                        opacity: isButtonDisabled() ? '0.5' : '1'
                                                                    }}>
                                                                        <img src={WhatsappIcon} alt="Ekle" style={{ height: '16px' }} /> 
                                                                        <span>Gönder</span>
                                                                </button>
                                                                </div>
                                                                {/* "Gönderilen No" bölümü güncellendi */}
                                                                {console.log('Mevcut rol:', localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).rol : null)}
                                                                {(localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).rol === 'depo_operatoru') ? null : (
                                                                    <div>
                                                                        <div style={{...detailStyles.actionGroup, justifyContent: 'space-between', marginBottom: '8px' }}>
                                                                            <label>Gönderim Numarası</label>
                                                                        </div>
                                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                                            <input 
                                                                                type="text" 
                                                                                style={{...detailStyles.input, flex: 1}} 
                                                                                value={proformaTel} 
                                                                                onChange={(e) => setProformaTel(e.target.value)}
                                                                                disabled={localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).rol === 'depo_operatoru'}
                                                                            />
                                                                            <button 
                                                                                style={{
                                                                                    padding: '5px 10px',
                                                                                    background: '#F8F8F8',
                                                                                    color: 'black',
                                                                                    border: 'none',
                                                                                    borderRadius: '8px',
                                                                                    cursor: 'pointer',
                                                                                    fontSize: '13px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontWeight: '500',
                                                                                    border: '1px solid #ccc',
                                                                                }}
                                                                                onClick={() => handleSaveGonderimNumarasi()}
                                                                                disabled={!detayData || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).rol === 'depo_operatoru')}
                                                                            >
                                                                                Kaydet
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* "Ödeme Durumu" bölümü koşullu hale getirildi */}
                                                                {detayData.odeme_yontemi === 'E' && (
                                                                    <div>
                                                                        <h4 style={{...detailStyles.title, border: 'none', padding: 0, margin: '0 0 10px 0'}}>ÖDEME DURUMU</h4>
                                                                        
                                                                        {/* Mevcut Durum Paneli */}
                                                                        <div style={{ background: '#f0f0f0', padding: '10px', borderRadius: '4px', fontSize: '13px', borderLeft: `4px solid ${getDurumRengi(detayData.odeme_durumu)}` }}>
                                                                            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px'}}>
                                                                                <strong>Durum:</strong>
                                                                                <strong style={{ color: getDurumRengi(detayData.odeme_durumu) }}>{detayData.odeme_durumu || 'Yükleniyor...'}</strong>
                                                                            </div>
                                                                            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px', color: '#555'}}>
                                                                                <span>Toplam Tutar:</span>
                                                                                <span>{(detayData.toplam_bedel || 0).toFixed(2)} ₺</span>
                                                                            </div>
                                                                            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px', color: '#555'}}>
                                                                                <span>Ödenen Tutar:</span>
                                                                                <span>{(detayData.odenen_bedel || 0).toFixed(2)} ₺</span>
                                                                            </div>
                                                                            <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: '5px 0'}}/>
                                                                            <div style={{display: 'flex', justifyContent: 'space-between', fontWeight: 'bold'}}>
                                                                                <span>Kalan Tutar:</span>
                                                                                <span>{((detayData.toplam_bedel || 0) - (detayData.odenen_bedel || 0)).toFixed(2)} ₺</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                
                                                                <div>
                                                                    <h4 style={{...detailStyles.title, border: 'none', padding: 0, fontFamily: 'Poppins', margin: '15px 0 10px 0'}}>NOTLAR</h4>
                                                                        <textarea 
                                                                        style={detailStyles.noteArea} 
                                                                        placeholder="Bu teklife özel notlar..."
                                                                        value={musteriNotu}
                                                                        onChange={(e) => setMusteriNotu(e.target.value)}
                                                                    />
                                                                    <button
                                                                        style={{
                                                                            ...detailStyles.button, 
                                                                            width: '100%', 
                                                                            marginTop: '10px', 
                                                                            fontFamily: 'Poppins',
                                                                            cursor: 'pointer',
                                                                            opacity: '1'
                                                                        }}
                                                                        onClick={handleSaveNote}
                                                                    >
                                                                        Notu Kaydet
                                                                    </button>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            // Sadece 'Normal' durumdaysa çalışır
                                                                            if (detayData.kargo_durumu !== 'Beklemede') {
                                                                                handleBeklemeyeAl(detayData.id);
                                                                            }
                                                                        }}
                                                                        disabled={detayData.kargo_durumu === 'Beklemede'}
                                                                        style={{
                                                                            ...detailStyles.button,
                                                                            width: '100%',
                                                                            marginTop: '10px',
                                                                            fontFamily: 'poppins',
                                                                            // Duruma göre renk ve stil değiştir
                                                                            background: detayData.kargo_durumu === 'Beklemede' ? '#ffc107' : '#6c757d',
                                                                            color: detayData.kargo_durumu === 'Beklemede' ? 'black' : 'white',
                                                                            cursor: detayData.kargo_durumu === 'Beklemede' ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {detayData.kargo_durumu === 'Beklemede' ? 'Beklemede' : 'Siparişi Beklet'}
                                                                    </button>
                                                                    
                                                                    {/* Acil Gönder / Normal Gönder Butonu */}
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            // Duruma göre acil veya normal gönder
                                                                            if (detayData.kargo_durumu === 'Acil') {
                                                                                handleNormalGonder(detayData.id);
                                                                            } else {
                                                                                handleAcilGonder(detayData.id);
                                                                            }
                                                                        }}
                                                                        disabled={detayData.kargo_durumu === 'Beklemede'}
                                                                        style={{
                                                                            ...detailStyles.button,
                                                                            width: '100%',
                                                                            marginTop: '10px',
                                                                            fontFamily: 'poppins',
                                                                            // Duruma göre renk ve stil değiştir
                                                                            background: detayData.kargo_durumu === 'Acil' ? '#25bb45ff' : '#dc3545',
                                                                            color: 'white',
                                                                            cursor: detayData.kargo_durumu === 'Beklemede' ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                    >
                                                                        {detayData.kargo_durumu === 'Acil' ? 'Normal Gönder' : 'Acil Gönder'}
                                                                    </button>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                    </div>

                                                    {/* Sütun 2: Gönderi Takip İşlemleri */}
                                                    <div style={detailStyles.column}>
                                                        <h3 style={detailStyles.title}>GÖNDERİ TAKİP İŞLEMLERİ</h3>
                                                        
                                                        {!detayData.kargo_takip_no ? (
                                                            <button
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    gap: '8px',
                                                                    width: '100%',
                                                                    padding: '10px',
                                                                    cursor: 'not-allowed',
                                                                    fontFamily: 'poppins',
                                                                    background: '#f8f8f8',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    opacity: '0.5'
                                                                }}
                                                                onClick={(e) => { 
                                                                    e.stopPropagation();
                                                                    alert('Demo modda PTT barkod işlemleri devre dışıdır.');
                                                                }}
                                                                disabled={true}
                                                            >
                                                                <img src={PTTLogo} alt="Gönderi Barkodu Oluştur" style={{ height: '14px' }} /><span>Gönderi Barkodu Oluştur (Demo)</span>
                                                            </button>
                                                        ) : (
                                                            <div>
                                                                {/* Takip Numarası ve Butonlar */}
                                                                <div>
                                                                    <label style={{fontWeight: '500'}}>PTT Kargo Takip Numarası:</label>
                                                                    <div style={{...detailStyles.actionGroup, justifyContent: 'space-between', marginTop: '8px'}}>
                                                                        <input 
                                                                            type="text" 
                                                                            style={{...detailStyles.input, flex: 1, background: '#e9ecef', fontWeight: 'bold', fontFamily: 'Poppins'}} 
                                                                            value={detayData.kargo_takip_no} 
                                                                            readOnly 
                                                                        />
                                                                        {/* --- BUTON GRUBU BURADA TEK BİR YERDE TOPLANDI --- */}
                                                                        <div style={{display: 'flex', gap: '5px', marginLeft: '10px', fontFamily: 'Poppins'}}>
                                                                            <button 
                                                                                style={{
                                                                                    ...detailStyles.button, 
                                                                                    fontFamily: 'Poppins',
                                                                                    cursor: kargoSorguLoading ? 'not-allowed' : 'pointer',
                                                                                    opacity: kargoSorguLoading ? '0.5' : '1'
                                                                                }}
                                                                                onClick={(e) => { 
                                                                                    e.stopPropagation(); 
                                                                                    handleQueryShipmentStatus(detayData.kargo_takip_no);
                                                                                }}
                                                                                disabled={kargoSorguLoading}
                                                                            >
                                                                                {kargoSorguLoading ? '...' : 'Sorgula'}
                                                                            </button>
                                                                            <button 
                                                                                style={{
                                                                                    ...detailStyles.button, 
                                                                                    background: '#ffc107', 
                                                                                    color: 'black', 
                                                                                    fontFamily: 'Poppins',
                                                                                    cursor: isShipmentUpdateDisabled() ? 'not-allowed' : 'pointer',
                                                                                    opacity: isShipmentUpdateDisabled() ? '0.5' : '1'
                                                                                }}
                                                                                onClick={(e) => { 
                                                                                    e.stopPropagation(); 
                                                                                    if (!isShipmentUpdateDisabled()) {
                                                                                        handleUpdatePttShipment(detayData.id);
                                                                                    }
                                                                                }}
                                                                                disabled={isShipmentUpdateDisabled()}
                                                                                title="Kargo Bilgilerini Güncelle ve Yeni Barkod Al"
                                                                            >
                                                                                Güncelle
                                                                            </button>
                                                                            <button 
                                                                                style={{
                                                                                    ...detailStyles.button, 
                                                                                    background: '#6c757d', 
                                                                                    color: 'white', 
                                                                                    fontFamily: 'Poppins',
                                                                                    cursor: isButtonDisabled() ? 'not-allowed' : 'pointer',
                                                                                    opacity: isButtonDisabled() ? '0.5' : '1'
                                                                                }}
                                                                                title="Etiketi PNG olarak indir"
                                                                                onClick={(e) => { 
                                                                                    e.stopPropagation(); 
                                                                                    if (!isButtonDisabled()) {
                                                                                        handleDownloadLabel(detayData);
                                                                                    }
                                                                                }}
                                                                                disabled={isButtonDisabled()}
                                                                            >
                                                                                Etiket İndir
                                                                            </button>
                                                                        </div>
                                                                        {/* Etiketimizi, etrafında boşluk olan bir "kutu" içine alıyoruz */}
                                                                        
                                                                    </div>
                                                                </div>

                                                                {/* Gönderi Hareketleri */}
                                                                <div style={{marginTop: '15px'}}>
                                                                    <h4 style={{...detailStyles.title, border: 'none', padding: 0, margin: '0 0 10px 0'}}>Gönderi Hareketleri</h4>
                                                                    <div style={{fontSize: '12px', color: '#333', maxHeight: '150px', overflowY: 'auto'}}>
                                                                        {kargoHareketleri.length > 0 ? (
                                                                            kargoHareketleri.map((hareket, index) => (
                                                                                <div key={index} style={{borderBottom: '1px solid #eee', padding: '8px 0'}}>
                                                                                    <p style={{margin: 0}}><strong>{hareket.durum}</strong></p>
                                                                                    <p style={{margin: '4px 0 0 0', color: '#666'}}>{hareket.yer} - {hareket.tarih} {hareket.saat}</p>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p style={{color: '#888'}}>Sorgulama bekleniyor veya hareket bulunamadı.</p>
                                                                        )}
                                                                    </div>

                                                                {/* Etiket Önizleme ve İndirme Butonu */}
                                                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '10px'}}>
                                                                        <h4 style={{...detailStyles.title, border: 'none', padding: 0, margin: 0}}>Etiket Önizleme</h4>
                                                                        {/* Not: İndirme butonu yukarı taşındığı için buradan kaldırıldı. */}
                                                                    </div>
                                                                </div>
                                                                <div id={`etiket-wrapper-${detayData.id}`} style={{ padding: '5px', display: 'inline-block', backgroundColor: 'white' }}>
                                                                    <EtiketSablonu teklif={detayData} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* SÜTUN 3: Faturalama İşlemleri */}
                            
                                                    <div style={detailStyles.column}>
                                                        <h3 style={detailStyles.title}>FATURALAMA İŞLEMLERİ</h3>
                                                        
                                                        {/* Henüz fatura oluşturulmamışsa "Oluştur" butonunu göster */}
                                                        {!detayData.parasut_fatura_id ? (            
                                                            <div>
                                                                {/* E-Fatura Oluştur butonu en üste */}
                                                                <button
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        gap: '8px',
                                                                        width: '100%',
                                                                        padding: '10px',
                                                                        cursor: 'not-allowed',
                                                                        fontFamily: 'poppins',
                                                                        background: '#f8f8f8',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px',
                                                                        opacity: '0.5',
                                                                        marginBottom: '15px'
                                                                    }}
                                                                    onClick={(e) => { 
                                                                        e.stopPropagation();
                                                                        alert('Demo modda Paraşüt fatura işlemleri devre dışıdır.');
                                                                    }}
                                                                    disabled={true}
                                                                >
                                                                    <img src={ParasutLogo} alt="E-Fatura Oluştur" style={{ height: '16px' }} />
                                                                    <span>E-Fatura Oluştur (Demo)</span>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            /* Fatura oluşturulmuş - yeni basit tasarım */
                                                            <div>
                                                                {/* Fatura ID ve Durum */}
                                                                <div style={{marginBottom: '14px'}}>
                                                                    <p style={{margin: 0, fontSize: '13px'}}>
                                                                        <strong>Fatura ID:</strong> {detayData.parasut_fatura_id}
                                                                    </p>
                                                                    <p style={{margin: '5px 0 0 0', fontSize: '13px'}}>
                                                                        <strong>Durum:</strong> {faturaStatuslari[detayData.parasut_fatura_id]?.is_finalized ? 'Resmileşti' : 'Oluşturuldu'}
                                                                    </p>
                                                                </div>
                                                                
                                                                {/* İnce çizgi */}
                                                                <hr style={{border: 'none', borderTop: '1px solid #ddd', margin: '15px 0'}}/>
                                                                
                                                                {/* Resmiyet Durumu */}
                                                                <div style={{marginBottom: '14px'}}>
                                                                    <h4 style={{margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#555'}}>
                                                                        E-FATURA DURUMU
                                                                    </h4>
                                                                    {faturaStatuslari[detayData.parasut_fatura_id] ? (
                                                                        faturaStatuslari[detayData.parasut_fatura_id].is_finalized ? (
                                                                            <div style={{fontSize: '13px'}}>
                                                                                <p style={{margin: '0 0 8px 0', fontWeight: 'bold', color: '#28a745'}}>Resmileştirildi</p>
                                                                                {faturaStatuslari[detayData.parasut_fatura_id].fatura_bilgileri && (
                                                                                    <>
                                                                                        <p style={{margin: '5px 0', color: '#000'}}>
                                                                                            <strong>Fatura No:</strong> {faturaStatuslari[detayData.parasut_fatura_id].fatura_bilgileri.fatura_no}
                                                                                        </p>
                                                                                        <p style={{margin: '5px 0', color: '#000'}}>
                                                                                            <strong>Fatura Tarihi:</strong> {faturaStatuslari[detayData.parasut_fatura_id].fatura_bilgileri.duzenlenme_tarihi}
                                                                                        </p>
                                                                                        <p style={{margin: '5px 0', color: '#000'}}>
                                                                                            <strong>Tutar:</strong> {faturaStatuslari[detayData.parasut_fatura_id].fatura_bilgileri.tutar} {faturaStatuslari[detayData.parasut_fatura_id].fatura_bilgileri.para_birimi}
                                                                                        </p>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <div style={{fontSize: '13px'}}>
                                                                                <p style={{margin: '0 0 8px 0', fontWeight: 'bold', color: '#dc3545'}}>Henüz resmileştirilmedi</p>
                                                                                <p style={{margin: '5px 0', fontSize: '12px', color: '#666'}}>
                                                                                    Paraşüt panelinden manuel resmileştirme yapılması gerekiyor.
                                                                                </p>
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <p style={{margin: 0, fontSize: '13px', color: '#666'}}>Durum kontrol ediliyor...</p>
                                                                    )}
                                                                </div>
                                                                
                                                                {/* Butonlar */}
                                                                <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                                                    {/* Paraşüt'te Görüntüle Butonu */}
                                                                    <a 
                                                                        href={`https://uygulama.parasut.com/365186/satislar/${detayData.parasut_fatura_id}`} 
                                                                        target="_blank" 
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            ...detailStyles.button, 
                                                                            textDecoration: 'none', 
                                                                            color: 'black', 
                                                                            textAlign: 'center', 
                                                                            boxSizing: 'border-box', 
                                                                            width: '100%',
                                                                            display: 'block'
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Paraşüt'te Görüntüle
                                                                    </a>

                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>Gösterilecek sipariş bulunamadı.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => handleModalClose(false)}>
                <TeklifGirisFormu 
                    teklifId={editingTeklifId}
                    onClose={handleModalClose}
                    onTeklifEklendi={(yeniTeklif) => handleModalClose(false, yeniTeklif)}
                />
            </Modal>
            
            {/* Tarih Seçim Modal'ı */}
            {tarihModalAcik && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#F8F8F8',
                        borderRadius: '8px',
                        padding: '25px',
                        minWidth: '400px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        fontFamily: 'Poppins, sans-serif',
                        border: '1px solid #E0E0E0'
                    }}>
                        <h2 style={{
                            margin: '0 0 20px 0',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#333',
                            textAlign: 'left',
                            borderBottom: '2px solid #E0E0E0',
                            paddingBottom: '12px'
                        }}>
                            📅 Sipariş Tarihi Seçin
                        </h2>
                        
                        <div style={{
                            marginBottom: '20px'
                        }}>
                            <input
                                type="date"
                                value={secilenTarih}
                                max={new Date().toISOString().split('T')[0]}
                                onChange={(e) => setSecilenTarih(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '6px 12px',
                                    fontSize: '14px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    backgroundColor: 'white'
                                }}
                            />
                        </div>
                        
                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setTarihModalAcik(false)}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleTarihOnayla}
                                style={{
                                    padding: '6px 16px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#F7F7F7',
                                    color: '#666',
                                    cursor: 'pointer',
                                    fontFamily: 'Poppins, sans-serif'
                                }}
                            >
                                Onayla
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TeklifListesi;




